import React, { useEffect, useState } from 'react'
import ModalActionButton from '../../elements/ModalActionButton'
import { useDispatch, useSelector } from 'react-redux'
import { clearUpdatedApplication, updateApplicationExam } from '../../../store/actions/applicationsActions'
import { ERROR, SET_SUCCESS } from '../../../store/types'
import TextareaField from '../../elements/form/TextareaField'

const RejectApplication = ({application, closeFunction, reload}) => {
  const dispatch = useDispatch()
  const applicationsSelector = useSelector((state => state.applications))

  const [validationErrors, setValidationErrors] = useState({});

  useEffect(() => {
      if(applicationsSelector.updatedApplication !== null) {
          dispatch({
              type: SET_SUCCESS,
              payload: 'application has been rejected!'
          })
          dispatch(clearUpdatedApplication())
          reload()
          setTimeout(() => {
              closeFunction()
          }, 50);
      }
      return () => {
          
      };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applicationsSelector.updatedApplication, closeFunction, dispatch]);

  const [rejectionReason, setRejectionReason] = useState('');

  const validateForm = () => {
      let errors = {}
      if(!rejectionReason || rejectionReason === '') {
          errors.score = true
      }


      setValidationErrors(errors)

      return errors
  }

  const pushScore = () => {
      if (Object.values(validateForm()).includes(true)) {
          dispatch({
              type: ERROR,
              error: {response: {data: {
                  message: 'Please check the highlighted fields'
              }}}
          })
          return
      }

      dispatch(updateApplicationExam(application._id, {
          status: 'REJECTED',
          rejectionReason: rejectionReason
      }))

  }

  return (
    <div className='w-full'>
          <div className='pb-3 border-b'>
              <p className='text-sm'>This application will be rejected. Please provide a reason below why you are rejecting the application and click on the "Reject application" button.</p>
          </div>
          <div className='mt-4 relative'>
            <TextareaField
                inputLabel="Document Description" 
                fieldId="case-summary" 
                inputType="text" 
                preloadValue={''}
                hasError={validationErrors && validationErrors.description} 
                returnFieldValue={(value)=>{setRejectionReason(value)}}
            />
          </div>

          <div className="mt-8 flex flex-row-reverse gap-x-4">
              <ModalActionButton
                  buttonLabel={`Reject application`}
                  buttonAction={()=>{pushScore()}}
                  processing={applicationsSelector.updatingApplication}
              />

              <button
                  type="button"
                  className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                  onClick={closeFunction}
              >
                  Close
              </button>
              
          </div>
      </div>
  )
}

export default RejectApplication